"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const prop_types_1 = __importDefault(require("prop-types"));
const get_css_1 = __importDefault(require("../get-css"));
const regex_1 = require("../utils/regex");
exports.propTypes = {
    border: prop_types_1.default.string,
    borderBottom: prop_types_1.default.string,
    borderBottomColor: prop_types_1.default.string,
    borderBottomStyle: prop_types_1.default.string,
    borderBottomWidth: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]),
    borderColor: prop_types_1.default.string,
    borderLeft: prop_types_1.default.string,
    borderLeftColor: prop_types_1.default.string,
    borderLeftStyle: prop_types_1.default.string,
    borderLeftWidth: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]),
    borderRight: prop_types_1.default.string,
    borderRightColor: prop_types_1.default.string,
    borderRightStyle: prop_types_1.default.string,
    borderRightWidth: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]),
    borderStyle: prop_types_1.default.string,
    borderTop: prop_types_1.default.string,
    borderTopColor: prop_types_1.default.string,
    borderTopStyle: prop_types_1.default.string,
    borderTopWidth: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]),
    borderWidth: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number])
};
exports.propAliases = {
    border: ['borderBottom', 'borderLeft', 'borderRight', 'borderTop'],
    borderColor: [
        'borderBottomColor',
        'borderLeftColor',
        'borderRightColor',
        'borderTopColor'
    ],
    borderStyle: [
        'borderBottomStyle',
        'borderLeftStyle',
        'borderRightStyle',
        'borderTopStyle'
    ],
    borderWidth: [
        'borderBottomWidth',
        'borderLeftWidth',
        'borderRightWidth',
        'borderTopWidth'
    ]
};
exports.propValidators = {};
if (process.env.NODE_ENV !== 'production') {
    exports.propValidators.borderColor = value => {
        if (regex_1.spacesOutsideParentheses.test(value)) {
            return `multiple values (“${value}”) aren՚t supported with “borderColor”. Use “borderBottomColor”, “borderLeftColor” “borderRightColor” and “borderTopColor” instead.`;
        }
        return;
    };
    exports.propValidators.borderStyle = value => {
        if (regex_1.spacesOutsideParentheses.test(value)) {
            return `multiple values (“${value}”) aren՚t supported with “borderStyle”. Use “borderBottomStyle”, “borderLeftStyle” “borderRightStyle” and “borderTopStyle” instead.`;
        }
        return;
    };
    exports.propValidators.borderWidth = value => {
        if (regex_1.spacesOutsideParentheses.test(value)) {
            return `multiple values (“${value}”) aren՚t supported with “borderWidth”. Use “borderBottomWidth”, “borderLeftWidth” “borderRightWidth” and “borderTopWidth” instead.`;
        }
        return;
    };
}
const borderLeft = {
    className: 'b-lft',
    cssName: 'border-left',
    jsName: 'borderLeft'
};
const borderLeftColor = {
    className: 'b-lft-clr',
    cssName: 'border-left-color',
    jsName: 'borderLeftColor'
};
const borderLeftStyle = {
    className: 'b-lft-stl',
    cssName: 'border-left-style',
    jsName: 'borderLeftStyle',
    safeValue: true
};
const borderLeftWidth = {
    className: 'b-lft-wdt',
    cssName: 'border-left-width',
    jsName: 'borderLeftWidth'
};
const borderRight = {
    className: 'b-rgt',
    cssName: 'border-right',
    jsName: 'borderRight'
};
const borderRightColor = {
    className: 'b-rgt-clr',
    cssName: 'border-right-color',
    jsName: 'borderRightColor'
};
const borderRightStyle = {
    className: 'b-rgt-stl',
    cssName: 'border-right-style',
    jsName: 'borderRightStyle',
    safeValue: true
};
const borderRightWidth = {
    className: 'b-rgt-wdt',
    cssName: 'border-right-width',
    jsName: 'borderRightWidth'
};
const borderTop = {
    className: 'b-top',
    cssName: 'border-top',
    jsName: 'borderTop'
};
const borderTopColor = {
    className: 'b-top-clr',
    cssName: 'border-top-color',
    jsName: 'borderTopColor'
};
const borderTopStyle = {
    className: 'b-top-stl',
    cssName: 'border-top-style',
    jsName: 'borderTopStyle',
    safeValue: true
};
const borderTopWidth = {
    className: 'b-top-wdt',
    cssName: 'border-top-width',
    jsName: 'borderTopWidth'
};
const borderBottom = {
    className: 'b-btm',
    cssName: 'border-bottom',
    jsName: 'borderBottom'
};
const borderBottomColor = {
    className: 'b-btm-clr',
    cssName: 'border-bottom-color',
    jsName: 'borderBottomColor'
};
const borderBottomStyle = {
    className: 'b-btm-stl',
    cssName: 'border-bottom-style',
    jsName: 'borderBottomStyle',
    safeValue: true
};
const borderBottomWidth = {
    className: 'b-btm-wdt',
    cssName: 'border-bottom-width',
    jsName: 'borderBottomWidth'
};
exports.propEnhancers = {
    borderBottom: (value) => get_css_1.default(borderBottom, value),
    borderBottomColor: (value) => get_css_1.default(borderBottomColor, value),
    borderBottomStyle: (value) => get_css_1.default(borderBottomStyle, value),
    borderBottomWidth: (value) => get_css_1.default(borderBottomWidth, value),
    borderLeft: (value) => get_css_1.default(borderLeft, value),
    borderLeftColor: (value) => get_css_1.default(borderLeftColor, value),
    borderLeftStyle: (value) => get_css_1.default(borderLeftStyle, value),
    borderLeftWidth: (value) => get_css_1.default(borderLeftWidth, value),
    borderRight: (value) => get_css_1.default(borderRight, value),
    borderRightColor: (value) => get_css_1.default(borderRightColor, value),
    borderRightStyle: (value) => get_css_1.default(borderRightStyle, value),
    borderRightWidth: (value) => get_css_1.default(borderRightWidth, value),
    borderTop: (value) => get_css_1.default(borderTop, value),
    borderTopColor: (value) => get_css_1.default(borderTopColor, value),
    borderTopStyle: (value) => get_css_1.default(borderTopStyle, value),
    borderTopWidth: (value) => get_css_1.default(borderTopWidth, value)
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYm9yZGVycy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9lbmhhbmNlcnMvYm9yZGVycy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7OztBQUFBLDREQUFrQztBQUNsQyx5REFBK0I7QUFDL0IsMENBQXVEO0FBRzFDLFFBQUEsU0FBUyxHQUFxQjtJQUN6QyxNQUFNLEVBQUUsb0JBQVMsQ0FBQyxNQUFNO0lBQ3hCLFlBQVksRUFBRSxvQkFBUyxDQUFDLE1BQU07SUFDOUIsaUJBQWlCLEVBQUUsb0JBQVMsQ0FBQyxNQUFNO0lBQ25DLGlCQUFpQixFQUFFLG9CQUFTLENBQUMsTUFBTTtJQUNuQyxpQkFBaUIsRUFBRSxvQkFBUyxDQUFDLFNBQVMsQ0FBQyxDQUFDLG9CQUFTLENBQUMsTUFBTSxFQUFFLG9CQUFTLENBQUMsTUFBTSxDQUFDLENBQUM7SUFDNUUsV0FBVyxFQUFFLG9CQUFTLENBQUMsTUFBTTtJQUM3QixVQUFVLEVBQUUsb0JBQVMsQ0FBQyxNQUFNO0lBQzVCLGVBQWUsRUFBRSxvQkFBUyxDQUFDLE1BQU07SUFDakMsZUFBZSxFQUFFLG9CQUFTLENBQUMsTUFBTTtJQUNqQyxlQUFlLEVBQUUsb0JBQVMsQ0FBQyxTQUFTLENBQUMsQ0FBQyxvQkFBUyxDQUFDLE1BQU0sRUFBRSxvQkFBUyxDQUFDLE1BQU0sQ0FBQyxDQUFDO0lBQzFFLFdBQVcsRUFBRSxvQkFBUyxDQUFDLE1BQU07SUFDN0IsZ0JBQWdCLEVBQUUsb0JBQVMsQ0FBQyxNQUFNO0lBQ2xDLGdCQUFnQixFQUFFLG9CQUFTLENBQUMsTUFBTTtJQUNsQyxnQkFBZ0IsRUFBRSxvQkFBUyxDQUFDLFNBQVMsQ0FBQyxDQUFDLG9CQUFTLENBQUMsTUFBTSxFQUFFLG9CQUFTLENBQUMsTUFBTSxDQUFDLENBQUM7SUFDM0UsV0FBVyxFQUFFLG9CQUFTLENBQUMsTUFBTTtJQUM3QixTQUFTLEVBQUUsb0JBQVMsQ0FBQyxNQUFNO0lBQzNCLGNBQWMsRUFBRSxvQkFBUyxDQUFDLE1BQU07SUFDaEMsY0FBYyxFQUFFLG9CQUFTLENBQUMsTUFBTTtJQUNoQyxjQUFjLEVBQUUsb0JBQVMsQ0FBQyxTQUFTLENBQUMsQ0FBQyxvQkFBUyxDQUFDLE1BQU0sRUFBRSxvQkFBUyxDQUFDLE1BQU0sQ0FBQyxDQUFDO0lBQ3pFLFdBQVcsRUFBRSxvQkFBUyxDQUFDLFNBQVMsQ0FBQyxDQUFDLG9CQUFTLENBQUMsTUFBTSxFQUFFLG9CQUFTLENBQUMsTUFBTSxDQUFDLENBQUM7Q0FDdkUsQ0FBQTtBQUVZLFFBQUEsV0FBVyxHQUFHO0lBQ3pCLE1BQU0sRUFBRSxDQUFDLGNBQWMsRUFBRSxZQUFZLEVBQUUsYUFBYSxFQUFFLFdBQVcsQ0FBQztJQUNsRSxXQUFXLEVBQUU7UUFDWCxtQkFBbUI7UUFDbkIsaUJBQWlCO1FBQ2pCLGtCQUFrQjtRQUNsQixnQkFBZ0I7S0FDakI7SUFDRCxXQUFXLEVBQUU7UUFDWCxtQkFBbUI7UUFDbkIsaUJBQWlCO1FBQ2pCLGtCQUFrQjtRQUNsQixnQkFBZ0I7S0FDakI7SUFDRCxXQUFXLEVBQUU7UUFDWCxtQkFBbUI7UUFDbkIsaUJBQWlCO1FBQ2pCLGtCQUFrQjtRQUNsQixnQkFBZ0I7S0FDakI7Q0FDRixDQUFBO0FBRVksUUFBQSxjQUFjLEdBQW1CLEVBQUcsQ0FBQTtBQUVqRCxJQUFJLE9BQU8sQ0FBQyxHQUFHLENBQUMsUUFBUSxLQUFLLFlBQVksRUFBRTtJQUN6QyxzQkFBYyxDQUFDLFdBQVcsR0FBRyxLQUFLLENBQUMsRUFBRTtRQUNuQyxJQUFJLGdDQUF3QixDQUFDLElBQUksQ0FBQyxLQUFLLENBQUMsRUFBRTtZQUN4QyxPQUFPLHFCQUFxQixLQUFLLHFJQUFxSSxDQUFBO1NBQ3ZLO1FBRUQsT0FBTTtJQUNSLENBQUMsQ0FBQTtJQUNELHNCQUFjLENBQUMsV0FBVyxHQUFHLEtBQUssQ0FBQyxFQUFFO1FBQ25DLElBQUksZ0NBQXdCLENBQUMsSUFBSSxDQUFDLEtBQUssQ0FBQyxFQUFFO1lBQ3hDLE9BQU8scUJBQXFCLEtBQUsscUlBQXFJLENBQUE7U0FDdks7UUFFRCxPQUFNO0lBQ1IsQ0FBQyxDQUFBO0lBQ0Qsc0JBQWMsQ0FBQyxXQUFXLEdBQUcsS0FBSyxDQUFDLEVBQUU7UUFDbkMsSUFBSSxnQ0FBd0IsQ0FBQyxJQUFJLENBQUMsS0FBSyxDQUFDLEVBQUU7WUFDeEMsT0FBTyxxQkFBcUIsS0FBSyxxSUFBcUksQ0FBQTtTQUN2SztRQUVELE9BQU07SUFDUixDQUFDLENBQUE7Q0FDRjtBQUVELE1BQU0sVUFBVSxHQUFHO0lBQ2pCLFNBQVMsRUFBRSxPQUFPO0lBQ2xCLE9BQU8sRUFBRSxhQUFhO0lBQ3RCLE1BQU0sRUFBRSxZQUFZO0NBQ3JCLENBQUE7QUFDRCxNQUFNLGVBQWUsR0FBRztJQUN0QixTQUFTLEVBQUUsV0FBVztJQUN0QixPQUFPLEVBQUUsbUJBQW1CO0lBQzVCLE1BQU0sRUFBRSxpQkFBaUI7Q0FDMUIsQ0FBQTtBQUNELE1BQU0sZUFBZSxHQUFHO0lBQ3RCLFNBQVMsRUFBRSxXQUFXO0lBQ3RCLE9BQU8sRUFBRSxtQkFBbUI7SUFDNUIsTUFBTSxFQUFFLGlCQUFpQjtJQUN6QixTQUFTLEVBQUUsSUFBSTtDQUNoQixDQUFBO0FBQ0QsTUFBTSxlQUFlLEdBQUc7SUFDdEIsU0FBUyxFQUFFLFdBQVc7SUFDdEIsT0FBTyxFQUFFLG1CQUFtQjtJQUM1QixNQUFNLEVBQUUsaUJBQWlCO0NBQzFCLENBQUE7QUFDRCxNQUFNLFdBQVcsR0FBRztJQUNsQixTQUFTLEVBQUUsT0FBTztJQUNsQixPQUFPLEVBQUUsY0FBYztJQUN2QixNQUFNLEVBQUUsYUFBYTtDQUN0QixDQUFBO0FBQ0QsTUFBTSxnQkFBZ0IsR0FBRztJQUN2QixTQUFTLEVBQUUsV0FBVztJQUN0QixPQUFPLEVBQUUsb0JBQW9CO0lBQzdCLE1BQU0sRUFBRSxrQkFBa0I7Q0FDM0IsQ0FBQTtBQUNELE1BQU0sZ0JBQWdCLEdBQUc7SUFDdkIsU0FBUyxFQUFFLFdBQVc7SUFDdEIsT0FBTyxFQUFFLG9CQUFvQjtJQUM3QixNQUFNLEVBQUUsa0JBQWtCO0lBQzFCLFNBQVMsRUFBRSxJQUFJO0NBQ2hCLENBQUE7QUFDRCxNQUFNLGdCQUFnQixHQUFHO0lBQ3ZCLFNBQVMsRUFBRSxXQUFXO0lBQ3RCLE9BQU8sRUFBRSxvQkFBb0I7SUFDN0IsTUFBTSxFQUFFLGtCQUFrQjtDQUMzQixDQUFBO0FBQ0QsTUFBTSxTQUFTLEdBQUc7SUFDaEIsU0FBUyxFQUFFLE9BQU87SUFDbEIsT0FBTyxFQUFFLFlBQVk7SUFDckIsTUFBTSxFQUFFLFdBQVc7Q0FDcEIsQ0FBQTtBQUNELE1BQU0sY0FBYyxHQUFHO0lBQ3JCLFNBQVMsRUFBRSxXQUFXO0lBQ3RCLE9BQU8sRUFBRSxrQkFBa0I7SUFDM0IsTUFBTSxFQUFFLGdCQUFnQjtDQUN6QixDQUFBO0FBQ0QsTUFBTSxjQUFjLEdBQUc7SUFDckIsU0FBUyxFQUFFLFdBQVc7SUFDdEIsT0FBTyxFQUFFLGtCQUFrQjtJQUMzQixNQUFNLEVBQUUsZ0JBQWdCO0lBQ3hCLFNBQVMsRUFBRSxJQUFJO0NBQ2hCLENBQUE7QUFDRCxNQUFNLGNBQWMsR0FBRztJQUNyQixTQUFTLEVBQUUsV0FBVztJQUN0QixPQUFPLEVBQUUsa0JBQWtCO0lBQzNCLE1BQU0sRUFBRSxnQkFBZ0I7Q0FDekIsQ0FBQTtBQUNELE1BQU0sWUFBWSxHQUFHO0lBQ25CLFNBQVMsRUFBRSxPQUFPO0lBQ2xCLE9BQU8sRUFBRSxlQUFlO0lBQ3hCLE1BQU0sRUFBRSxjQUFjO0NBQ3ZCLENBQUE7QUFDRCxNQUFNLGlCQUFpQixHQUFHO0lBQ3hCLFNBQVMsRUFBRSxXQUFXO0lBQ3RCLE9BQU8sRUFBRSxxQkFBcUI7SUFDOUIsTUFBTSxFQUFFLG1CQUFtQjtDQUM1QixDQUFBO0FBQ0QsTUFBTSxpQkFBaUIsR0FBRztJQUN4QixTQUFTLEVBQUUsV0FBVztJQUN0QixPQUFPLEVBQUUscUJBQXFCO0lBQzlCLE1BQU0sRUFBRSxtQkFBbUI7SUFDM0IsU0FBUyxFQUFFLElBQUk7Q0FDaEIsQ0FBQTtBQUNELE1BQU0saUJBQWlCLEdBQUc7SUFDeEIsU0FBUyxFQUFFLFdBQVc7SUFDdEIsT0FBTyxFQUFFLHFCQUFxQjtJQUM5QixNQUFNLEVBQUUsbUJBQW1CO0NBQzVCLENBQUE7QUFFWSxRQUFBLGFBQWEsR0FBa0I7SUFDMUMsWUFBWSxFQUFFLENBQUMsS0FBNEIsRUFBRSxFQUFFLENBQUMsaUJBQU0sQ0FBQyxZQUFZLEVBQUUsS0FBSyxDQUFDO0lBQzNFLGlCQUFpQixFQUFFLENBQUMsS0FBNEIsRUFBRSxFQUFFLENBQUMsaUJBQU0sQ0FBQyxpQkFBaUIsRUFBRSxLQUFLLENBQUM7SUFDckYsaUJBQWlCLEVBQUUsQ0FBQyxLQUE0QixFQUFFLEVBQUUsQ0FBQyxpQkFBTSxDQUFDLGlCQUFpQixFQUFFLEtBQUssQ0FBQztJQUNyRixpQkFBaUIsRUFBRSxDQUFDLEtBQTRCLEVBQUUsRUFBRSxDQUFDLGlCQUFNLENBQUMsaUJBQWlCLEVBQUUsS0FBSyxDQUFDO0lBQ3JGLFVBQVUsRUFBRSxDQUFDLEtBQTRCLEVBQUUsRUFBRSxDQUFDLGlCQUFNLENBQUMsVUFBVSxFQUFFLEtBQUssQ0FBQztJQUN2RSxlQUFlLEVBQUUsQ0FBQyxLQUE0QixFQUFFLEVBQUUsQ0FBQyxpQkFBTSxDQUFDLGVBQWUsRUFBRSxLQUFLLENBQUM7SUFDakYsZUFBZSxFQUFFLENBQUMsS0FBNEIsRUFBRSxFQUFFLENBQUMsaUJBQU0sQ0FBQyxlQUFlLEVBQUUsS0FBSyxDQUFDO0lBQ2pGLGVBQWUsRUFBRSxDQUFDLEtBQTRCLEVBQUUsRUFBRSxDQUFDLGlCQUFNLENBQUMsZUFBZSxFQUFFLEtBQUssQ0FBQztJQUNqRixXQUFXLEVBQUUsQ0FBQyxLQUE0QixFQUFFLEVBQUUsQ0FBQyxpQkFBTSxDQUFDLFdBQVcsRUFBRSxLQUFLLENBQUM7SUFDekUsZ0JBQWdCLEVBQUUsQ0FBQyxLQUE0QixFQUFFLEVBQUUsQ0FBQyxpQkFBTSxDQUFDLGdCQUFnQixFQUFFLEtBQUssQ0FBQztJQUNuRixnQkFBZ0IsRUFBRSxDQUFDLEtBQTRCLEVBQUUsRUFBRSxDQUFDLGlCQUFNLENBQUMsZ0JBQWdCLEVBQUUsS0FBSyxDQUFDO0lBQ25GLGdCQUFnQixFQUFFLENBQUMsS0FBNEIsRUFBRSxFQUFFLENBQUMsaUJBQU0sQ0FBQyxnQkFBZ0IsRUFBRSxLQUFLLENBQUM7SUFDbkYsU0FBUyxFQUFFLENBQUMsS0FBNEIsRUFBRSxFQUFFLENBQUMsaUJBQU0sQ0FBQyxTQUFTLEVBQUUsS0FBSyxDQUFDO0lBQ3JFLGNBQWMsRUFBRSxDQUFDLEtBQTRCLEVBQUUsRUFBRSxDQUFDLGlCQUFNLENBQUMsY0FBYyxFQUFFLEtBQUssQ0FBQztJQUMvRSxjQUFjLEVBQUUsQ0FBQyxLQUE0QixFQUFFLEVBQUUsQ0FBQyxpQkFBTSxDQUFDLGNBQWMsRUFBRSxLQUFLLENBQUM7SUFDL0UsY0FBYyxFQUFFLENBQUMsS0FBNEIsRUFBRSxFQUFFLENBQUMsaUJBQU0sQ0FBQyxjQUFjLEVBQUUsS0FBSyxDQUFDO0NBQ2hGLENBQUEifQ==